// src/pages/Community/News_UpdatesIndex.jsx
import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";
import { Link } from "react-router-dom";
import "./css/News_UpdatesIndex.css";
import { AiOutlineEye } from "react-icons/ai";
import { BiMessageRoundedDetail } from "react-icons/bi";
import { Helmet } from "react-helmet";

export default function News_UpdatesIndex() {
  const [articles, setArticles] = useState([]);

  const categoryIcons = {
    "News & Updates": "📰",
    "Guides & Tutorials": "📘",
    "Lore & Theories": "🧠",
    "Ranked Lists & Opinions": "📊",
    "Fan Content & Creativity": "🎨",
    "Game Reviews & Retrospectives": "🎮",
    "GTA RP Coverage": "🎭",
    "Community Spotlight": "🌟",
    "Mods & Technical Help": "🛠️",
    "Opinion & Editorials": "✍️",
  };

  const getCategoryIcon = (category) => categoryIcons[category] || "📄";

  useEffect(() => {
    const fetchArticles = async () => {
      const q = query(collection(db, "articles"), orderBy("timestamp", "desc"));
      const snap = await getDocs(q);
      const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setArticles(data);
    };

    fetchArticles();
  }, []);


  return (
    <>
      <Helmet>
        <title>GTAFanPage — News & Updates</title>
        <meta
          name="description"
          content="Official and community news, patch notes, and announcements for GTAFanPage."
        />
        <link rel="canonical" href="https://www.gtafanpage.com/community/news_updates" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="GTAFanPage — News & Updates" />
        <meta
          property="og:description"
          content="Stay up to date with announcements, patch notes and community news on GTAFanPage."
        />
        <meta property="og:url" content="https://www.gtafanpage.com/community/news_updates" />
        <meta property="og:image" content="https://www.gtafanpage.com/og-image.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="GTAFanPage — News & Updates" />
        <meta
          name="twitter:description"
          content="Announcements, patch notes, and community news for GTA fans."
        />
        <meta name="twitter:image" content="https://www.gtafanpage.com/og-image.jpg" />
      </Helmet>

        <div className="news-updates-wrapper">

          <div className="forum-style-list">
            {articles.length === 0 ? (
              <div className="empty">No news yet — check back soon.</div>
            ) : (
              articles.map((article) => (
                <div key={article.id} className="forum-thread-row">
                  <div className="left-section">
                    <div className="thread-info">
                      <div className="thread-title">
                        <span className="forum-icon-inline">
                          {getCategoryIcon(article.category)}
                        </span>
                        <Link to={`/community/news_updates/article/${article.id}`}>{article.title}</Link>
                      </div>

                      <div className="thread-meta">
                        {article.category} · {article.authorName || "Unknown"} ·{" "}
                        {article.timestamp?.toDate?.().toLocaleDateString?.("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        }) ?? "Just now"}
                      </div>

                      <div className="thread-description">
                        {
                          article.content
                            ?.replace(/[#>*`~]/g, "")
                            ?.split("\n")
                            ?.find((line) => line.trim().length > 0)
                        }
                      </div>

                      <div className="tags">
                        {article.tags?.map((tag) => (
                          <span key={tag} className="tag">
                            #{tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="right-section">
                    <div className="thread-stats">
                      <span className="stat">
                        <AiOutlineEye style={{ verticalAlign: "middle", marginRight: 4 }} />
                        {article.views || 0}
                      </span>
                      <span className="stat">
                        <BiMessageRoundedDetail style={{ verticalAlign: "middle", marginRight: 4 }} />
                        {article.reactions?.comment || 0}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
    </>
  );
}
